import axios from "axios";

export function fetchArticlesForCategory(
  clientCode,
  categoryId,
  language,
  externalUserId
) {
  let payload = {
    code: clientCode,
    id: categoryId,
    externalUserId,
  };

  return axios.post("/category/content", payload);
}
export function fetchArticles(
  externalUserId,
  code,
  type,
  previewCode,
  language
) {
  let payload = {
    externalUserId,
    code,
    type,
    previewCode,
  };

  return axios.post("/content", payload, {
    params: {
      lang: language,
    },
  });
}

export function fetchArticleDetails(
  articleId,
  clientCode,
  language,
  externalUserId
) {
  let payload = {
    code: clientCode,
    id: articleId,
    externalUserId,
  };

  return axios.post("/article", payload, {
    params: {
      lang: language,
    },
  });
}

export function searchArticles(
  clientCode,
  searchKeyword,
  articleType,
  language
) {
  let payload = {
    code: clientCode,
    searchKeyword: searchKeyword,
    type: articleType,
  };

  return axios.post("/content/search", payload, {
    params: {
      lang: language,
    },
  });
}

export function fetchArticlesForType(clientCode, articleType, language) {
  let payload = {
    code: clientCode,
    type: articleType,
  };

  return axios.post("/content", payload);
}

export function fetchPromotionArticles(clientCode) {
  let payload = {
    code: clientCode,
    previewCode: null,
  };

  return axios.post("/promotion-articles", payload);
}

export function sendSurveyResult(surveyId, answers) {
  let payload = {
    surveyId: surveyId,
    answerQuestion1: answers.answerQuestion1,
    answerQuestion2: answers.answerQuestion2,
    answerQuestion3: answers.answerQuestion3,
    answerQuestion4: answers.answerQuestion4,
  };

  return axios.post("/survey/log", payload);
}

export function startGoal(externalUserId, goalId) {
  let payload = {
    externalUserId,
    goalId,
  };

  return axios.post("/goal/start", payload);
}

export function stopGoal(externalUserId, goalId) {
  let payload = {
    externalUserId,
    goalId,
  };

  return axios.post("/goal/stop", payload);
}
